import { render, staticRenderFns } from "./inteRaOrder.vue?vue&type=template&id=c586ca40"
import script from "./inteRaOrder.vue?vue&type=script&lang=js"
export * from "./inteRaOrder.vue?vue&type=script&lang=js"
import style0 from "./inteRaOrder.vue?vue&type=style&index=0&id=c586ca40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports